import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import { animationGenerationStore, projectStore } from 'stores';
import { EXPORT_TYPES } from 'stores/animationGenerationStore';

export const useDownloadFreeInfo = (downloadFormat: EXPORT_TYPES) => {
  const { jobData, currentAnimationNumber } = useSnapshot(
    animationGenerationStore.state,
  );
  const { currentProject } = useSnapshot(projectStore.state);

  const [exportCostData, setExportCostData] = useState<{
    isFreeExport: boolean;
    costInSpins: number;
  } | null>(null);

  // Check if we're in a project context (new flow) vs legacy job context
  const isProjectContext = currentProject.data;

  // If we're in a project context, fetch export cost from API
  useEffect(() => {
    if (isProjectContext) {
      projectStore.checkExportCost(downloadFormat).then((data) => {
        if (data) {
          setExportCostData(data);
        }
      });
    }
  }, [isProjectContext, downloadFormat]);

  // Project context: Use API data
  if (isProjectContext) {
    const costInSpins = exportCostData?.costInSpins;
    return {
      downloadIsFree: costInSpins === 0,
      costInSpins: exportCostData?.costInSpins,
      showDownloadFreeExamples: costInSpins !== undefined && costInSpins > 0,
      isFreeExport: exportCostData?.isFreeExport,
    };
  }

  // Legacy job context: Use existing variation-based logic
  const variationInfo = jobData?.variationInfoByID[currentAnimationNumber];
  const userOwnsMayaMotion = Boolean(
    variationInfo?.mayaDownloadUnlockedAt &&
      variationInfo?.mayaDownloadUnlockedAt <= new Date().toISOString(),
  );
  const userOwnsNonMayaMotion = Boolean(
    variationInfo?.nonMayaDownloadUnlockedAt &&
      variationInfo?.nonMayaDownloadUnlockedAt <= new Date().toISOString(),
  );
  const costInSpins =
    downloadFormat === EXPORT_TYPES.MA || downloadFormat === EXPORT_TYPES.MB
      ? 100
      : 50;

  const downloadIsFree =
    (userOwnsMayaMotion &&
      (downloadFormat === EXPORT_TYPES.MA ||
        downloadFormat === EXPORT_TYPES.MB)) ||
    (userOwnsNonMayaMotion &&
      (downloadFormat === EXPORT_TYPES.BVH ||
        downloadFormat === EXPORT_TYPES.FBX_MAYA ||
        downloadFormat === EXPORT_TYPES.FBX_BLENDER ||
        downloadFormat === EXPORT_TYPES.FBX_UNREAL ||
        downloadFormat === EXPORT_TYPES.FBX_ROBLOX ||
        downloadFormat === EXPORT_TYPES.FBX_UNITY ||
        downloadFormat === EXPORT_TYPES.GLB ||
        downloadFormat === EXPORT_TYPES.USDZ));

  const showDownloadFreeExamples =
    ((downloadFormat === EXPORT_TYPES.MA ||
      downloadFormat === EXPORT_TYPES.MB) &&
      !userOwnsMayaMotion) ||
    ((downloadFormat === EXPORT_TYPES.BVH ||
      downloadFormat === EXPORT_TYPES.FBX_MAYA ||
      downloadFormat === EXPORT_TYPES.FBX_BLENDER ||
      downloadFormat === EXPORT_TYPES.FBX_UNREAL ||
      downloadFormat === EXPORT_TYPES.FBX_ROBLOX ||
      downloadFormat === EXPORT_TYPES.FBX_UNITY ||
      downloadFormat === EXPORT_TYPES.GLB ||
      downloadFormat === EXPORT_TYPES.USDZ) &&
      !userOwnsNonMayaMotion);

  return {
    downloadIsFree,
    costInSpins,
    showDownloadFreeExamples,
  };
};
